import axios from 'axios';

/**
 * Service for handling token icon uploads through Cloudinary
 */
class CloudinaryService {
  /**
   * Upload a token icon to Cloudinary
   * @param {File} iconFile - The icon file to upload
   * @param {string} issuer - Issuer address
   * @param {string} currency - Currency code
   * @returns {Promise<string>} - URL to the uploaded icon
   */
  async uploadTokenIcon(iconFile, issuer, currency) {
    try {
      // Create a FormData object for the file upload
      const formData = new FormData();
      formData.append('icon', iconFile);
      formData.append('issuer', issuer);
      formData.append('currency', currency);
      
      // Call our API endpoint that will handle the Cloudinary upload
      const response = await axios.post('/api/upload-icon', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      if (response.data && response.data.iconUrl) {
        return response.data.iconUrl;
      }
      
      throw new Error('Failed to get icon URL from response');
    } catch (error) {
      console.error('Error uploading token icon to Cloudinary:', error);
      throw error;
    }
  }
}

const cloudinaryService = new CloudinaryService();
export default cloudinaryService; 